import { BACK_BUTTON } from 'components/common/ActionBar/constants';
import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const CommittedFiltersDataSource = [
    {
        text: 'Lines With Committed Quantity',
        value: 'c',
    },
    {
        text: 'Lines With No Committed Quantity',
        value: 'u',
    },
];

const MappingFilter = {
    c: 'u',
    u: 'c'
};

export const quantityFilter = (filter) => (Array.isArray(filter) ?
    filter[0] === '!' ? MappingFilter[filter?.pop()] : filter?.pop()
    : '');

export const columns = [
    {
        dataField: 'ProductIdDisplay',
        caption: 'Product',
        width: COLUMN_SIZE.lg0
    },
    {
        dataField: 'ProductId',
        caption: 'ProductId',
        visible: false
    },
    {
        dataField: 'LineNumber',
        caption: 'LineNumber',
        visible: false
    },
    {
        dataField: 'OnOrderQuantity',
        caption: 'On Order',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md0,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right',
        allowHeaderFiltering: false,
    },
    {
        dataField: 'CommittedQuantity',
        caption: 'Committed',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md1,
        format: '#0.00',
        allowSorting: false,
        isEditable: true,
        alignment: 'right',
        filterType: 'exclude',
        headerFiltersDataSource: CommittedFiltersDataSource,
    },
    {
        dataField: 'UnitCode',
        caption: 'Unit',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.md1,
        allowSorting: false,
        allowEditing: false,
        allowHeaderFiltering: false,
    },
    {
        dataField: 'Description',
        caption: 'Description',
        minWidth: COLUMN_SIZE.md1,
        width: COLUMN_SIZE.lg0,
        allowSorting: false,
        allowEditing: false,
        allowHeaderFiltering: false,
    }
];

export const ActionBarIcons = {
    leftIcons: [BACK_BUTTON],
    centerIcons: [],
    rightIcons: []
};

export const LineCommitmentHeaderFilterHeight = '230';
export const LineCommitmentHeaderFilterWidth = '312';
